<form id="cookie-settings" #form="ngForm">
  <mui-modal-header [title]="'cookieSettings.dialog.title' | translate" [hideCloseButton]="true"></mui-modal-header>
  <div class="mui-modal__body cookie-details-body">
    <p [innerHTML]="'cookieSettings.dialog.entGTMTracking.description' | translate: { moreInfoLink: safeMoreInfoAnchor }"></p>

    <mmu-ff-ent-gtm-tracking-cookie-selection
      [(settings)]="settings"
      [formDisabled]="formDisabled"></mmu-ff-ent-gtm-tracking-cookie-selection>

    <mui-accordion>
      <mui-accordion-header class="cookie-details-accordion-header">
        <p class="cookie-details-accordion-title">{{ 'cookieSettings.dialog.details' | translate }}</p>
      </mui-accordion-header>
      <mui-accordion-content>
        <ng-container
          *ngTemplateOutlet="
            cookieDetails;
            context: {
              title: 'cookieSettings.banner.required.title' | translate,
              description: 'cookieSettings.banner.required.description' | translate
            }
          ">
        </ng-container>
        <ng-container
          *ngTemplateOutlet="
            cookieDetails;
            context: {
              title: 'cookieSettings.banner.analysis.title' | translate,
              description: 'cookieSettings.banner.analysis.description' | translate
            }
          ">
        </ng-container>
      </mui-accordion-content>
    </mui-accordion>
  </div>
  <mui-modal-footer>
    <button
      mui-btn
      appearance="secondary"
      id="accept-cookie-settings-button"
      [disabled]="formDisabled ? true : null"
      (click)="accept(form)">
      {{ 'cookieSettings.dialog.btn.accept' | translate }}
    </button>
    <button
      mui-btn
      #allowAllButton
      appearance="primary"
      icon="check"
      id="allow-all-cookie-settings-button"
      [disabled]="formDisabled ? true : null"
      (click)="selectAll(form)">
      {{ 'cookieSettings.dialog.btn.selectAndAcceptAll' | translate }}
    </button>
  </mui-modal-footer>
</form>

<ng-template #cookieDetails let-title="title" let-description="description">
  <div class="cookie-details-section">
    <h5 class="mt-0">{{ title }}</h5>
    <p>{{ description }}</p>
  </div>
</ng-template>
